declare global {
    interface StringConstructor {
      stringFormat(repString: string, ...args): string;
    }
  }

  String.stringFormat = function(repString: string, ...args) {
    return repString.replace(/{(\d+)}/g, function(match, number) { 
      return typeof args[number] != 'undefined'
        ? args[number]
        : match
      ;
    });
  };
  
  export {}